function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118.801 0C108.735 0 98.9746 4.17815 91.9959 11.7597L9.62736 101.246C0.812958 110.822 -2.22351 124.375 1.66202 136.797L37.9758 252.873C41.8621 265.296 52.0804 274.702 64.7827 277.547L183.463 304.137C186.109 304.73 188.778 305.02 191.428 305.02C201.494 305.02 211.256 300.841 218.235 293.259L300.603 203.773C309.418 194.196 312.454 180.644 308.567 168.221L272.254 52.1461C268.368 39.7236 258.15 30.3176 245.448 27.4714L126.767 0.88264C124.121 0.289416 121.45 0 118.801 0Z",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M262.047 174.782H137.712C135.647 174.782 133.974 173.108 133.974 171.043V28.6916C133.974 26.6265 135.647 24.9531 137.712 24.9531H262.047C264.112 24.9531 265.786 26.6265 265.786 28.6916V171.043C265.786 173.108 264.112 174.782 262.047 174.782Z",
  fill: "#B4B4B4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M252.926 182.586H146.833C144.768 182.586 143.094 180.912 143.094 178.847V20.8857C143.094 18.8206 144.768 17.1465 146.833 17.1465H252.926C254.99 17.1465 256.664 18.8206 256.664 20.8857V178.847C256.664 180.912 254.99 182.586 252.926 182.586Z",
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M165.751 44.5239H164.933C164.311 44.5239 163.809 44.0202 163.809 43.3998V42.5803C163.809 41.9599 164.311 41.457 164.933 41.457H165.751C166.372 41.457 166.875 41.9599 166.875 42.5803V43.3998C166.875 44.0202 166.372 44.5239 165.751 44.5239Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.446 44.5239H170.627C170.005 44.5239 169.502 44.0202 169.502 43.3998V42.5803C169.502 41.9599 170.005 41.457 170.627 41.457H171.446C172.066 41.457 172.569 41.9599 172.569 42.5803V43.3998C172.569 44.0202 172.066 44.5239 171.446 44.5239Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M177.139 44.5239H176.32C175.699 44.5239 175.196 44.0202 175.196 43.3998V42.5803C175.196 41.9599 175.699 41.457 176.32 41.457H177.139C177.759 41.457 178.263 41.9599 178.263 42.5803V43.3998C178.263 44.0202 177.759 44.5239 177.139 44.5239Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M165.751 50.4672H164.933C164.311 50.4672 163.809 49.9636 163.809 49.3432V48.5237C163.809 47.9033 164.311 47.4004 164.933 47.4004H165.751C166.372 47.4004 166.875 47.9033 166.875 48.5237V49.3432C166.875 49.9636 166.372 50.4672 165.751 50.4672Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.446 50.4672H170.627C170.005 50.4672 169.502 49.9636 169.502 49.3432V48.5237C169.502 47.9033 170.005 47.4004 170.627 47.4004H171.446C172.066 47.4004 172.569 47.9033 172.569 48.5237V49.3432C172.569 49.9636 172.066 50.4672 171.446 50.4672Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M177.139 50.4672H176.32C175.699 50.4672 175.196 49.9636 175.196 49.3432V48.5237C175.196 47.9033 175.699 47.4004 176.32 47.4004H177.139C177.759 47.4004 178.263 47.9033 178.263 48.5237V49.3432C178.263 49.9636 177.759 50.4672 177.139 50.4672Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M182.833 50.4672H182.015C181.394 50.4672 180.891 49.9636 180.891 49.3432V48.5237C180.891 47.9033 181.394 47.4004 182.015 47.4004H182.833C183.454 47.4004 183.957 47.9033 183.957 48.5237V49.3432C183.957 49.9636 183.454 50.4672 182.833 50.4672Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M165.751 55.8012H164.933C164.311 55.8012 163.809 55.2975 163.809 54.6779V53.8585C163.809 53.2381 164.311 52.7344 164.933 52.7344H165.751C166.372 52.7344 166.875 53.2381 166.875 53.8585V54.6779C166.875 55.2975 166.372 55.8012 165.751 55.8012Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.446 55.8012H170.627C170.005 55.8012 169.502 55.2975 169.502 54.6779V53.8585C169.502 53.2381 170.005 52.7344 170.627 52.7344H171.446C172.066 52.7344 172.569 53.2381 172.569 53.8585V54.6779C172.569 55.2975 172.066 55.8012 171.446 55.8012Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M177.139 55.8012H176.32C175.699 55.8012 175.196 55.2975 175.196 54.6779V53.8585C175.196 53.2381 175.699 52.7344 176.32 52.7344H177.139C177.759 52.7344 178.263 53.2381 178.263 53.8585V54.6779C178.263 55.2975 177.759 55.8012 177.139 55.8012Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M182.833 55.8012H182.015C181.394 55.8012 180.891 55.2975 180.891 54.6779V53.8585C180.891 53.2381 181.394 52.7344 182.015 52.7344H182.833C183.454 52.7344 183.957 53.2381 183.957 53.8585V54.6779C183.957 55.2975 183.454 55.8012 182.833 55.8012Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M188.527 50.4672H187.707C187.087 50.4672 186.583 49.9636 186.583 49.3432V48.5237C186.583 47.9033 187.087 47.4004 187.707 47.4004H188.527C189.147 47.4004 189.65 47.9033 189.65 48.5237V49.3432C189.65 49.9636 189.147 50.4672 188.527 50.4672Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M194.22 50.4672H193.401C192.78 50.4672 192.277 49.9636 192.277 49.3432V48.5237C192.277 47.9033 192.78 47.4004 193.401 47.4004H194.22C194.841 47.4004 195.343 47.9033 195.343 48.5237V49.3432C195.343 49.9636 194.841 50.4672 194.22 50.4672Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M199.914 50.4672H199.095C198.474 50.4672 197.971 49.9636 197.971 49.3432V48.5237C197.971 47.9033 198.474 47.4004 199.095 47.4004H199.914C200.535 47.4004 201.038 47.9033 201.038 48.5237V49.3432C201.038 49.9636 200.535 50.4672 199.914 50.4672Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M163.409 74.6235H221.27V66.0273H163.409V74.6235Z",
  fill: "#F9CE64"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M163.064 74.9661H221.614V65.6816H163.064V74.9661Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M163.409 158.276H189.624V149.533H163.409V158.276Z",
  fill: "#77A6DD"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M193.959 158.276H236.35V149.533H193.959V158.276Z",
  fill: "#77A6DD"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M202.246 86.77H165.018C163.939 86.77 163.064 85.8953 163.064 84.8176C163.064 83.7391 163.939 82.8652 165.018 82.8652H202.246C203.324 82.8652 204.198 83.7391 204.198 84.8176C204.198 85.8953 203.324 86.77 202.246 86.77Z",
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M202.246 97.7192H165.018C163.939 97.7192 163.064 96.8445 163.064 95.7668C163.064 94.6891 163.939 93.8145 165.018 93.8145H202.246C203.324 93.8145 204.198 94.6891 204.198 95.7668C204.198 96.8445 203.324 97.7192 202.246 97.7192Z",
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M202.246 108.668H165.018C163.939 108.668 163.064 107.795 163.064 106.717C163.064 105.638 163.939 104.764 165.018 104.764H202.246C203.324 104.764 204.198 105.638 204.198 106.717C204.198 107.795 203.324 108.668 202.246 108.668Z",
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M234.444 119.616H165.017C163.938 119.616 163.064 118.742 163.064 117.664C163.064 116.586 163.938 115.711 165.017 115.711H234.444C235.522 115.711 236.396 116.586 236.396 117.664C236.396 118.742 235.522 119.616 234.444 119.616Z",
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M234.444 130.565H165.017C163.938 130.565 163.064 129.69 163.064 128.613C163.064 127.534 163.938 126.66 165.017 126.66H234.444C235.522 126.66 236.396 127.534 236.396 128.613C236.396 129.69 235.522 130.565 234.444 130.565Z",
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M234.188 106.715H211.838C210.644 106.715 209.676 105.747 209.676 104.553V84.5876C209.676 83.394 210.644 82.4258 211.838 82.4258H234.188C235.383 82.4258 236.351 83.394 236.351 84.5876V104.553C236.351 105.747 235.383 106.715 234.188 106.715Z",
  fill: "#CCCCCC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M231.338 34.3943L227.162 33.4453L223.036 51.605L227.907 49.4927L231.388 53.5022L235.514 35.3433L231.338 34.3943Z",
  fill: "#77A6DD"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.09 34.3943L243.266 33.4453L247.393 51.605L242.521 49.4927L239.041 53.5022L234.914 35.3433L239.09 34.3943Z",
  fill: "#77A6DD"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M247.158 37.9519C247.354 39.6204 246.227 40.5007 244.655 39.909L242.344 39.0384C240.773 38.4468 238.813 39.1607 237.992 40.6254L236.782 42.7792C235.961 44.2439 234.532 44.2951 233.609 42.8919L232.25 40.8293C231.326 39.4262 229.323 38.8521 227.796 39.5549L225.553 40.5862C224.026 41.2882 222.841 40.4895 222.919 38.8113L223.032 36.3441C223.109 34.6668 221.825 33.0246 220.178 32.6952L217.756 32.2107C216.109 31.8813 215.62 30.539 216.668 29.227L218.211 27.2979C219.259 25.9851 219.186 23.9024 218.047 22.668L216.372 20.8531C215.232 19.6179 215.627 18.2444 217.246 17.7991L219.626 17.1451C221.246 16.6998 222.411 14.9713 222.215 13.3027L221.927 10.8499C221.731 9.18135 222.856 8.30111 224.429 8.89274L226.74 9.76338C228.313 10.3558 230.271 9.64106 231.093 8.17719L232.302 6.02256C233.124 4.55789 234.552 4.50832 235.476 5.91063L236.834 7.97332C237.757 9.37643 239.762 9.94967 241.289 9.24851L243.532 8.21637C245.058 7.51441 246.243 8.31311 246.166 9.99044L246.053 12.4577C245.975 14.1358 247.26 15.778 248.907 16.1074L251.329 16.591C252.976 16.9204 253.466 18.2628 252.416 19.5756L250.874 21.5047C249.826 22.8159 249.9 24.9002 251.038 26.1338L252.713 27.9494C253.852 29.1839 253.459 30.5582 251.839 31.0027L249.458 31.6575C247.839 32.102 246.673 33.8313 246.869 35.4998L247.158 37.9519Z",
  fill: "#7099CA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M246.408 24.4012C246.408 30.9539 241.095 36.2665 234.542 36.2665C227.989 36.2665 222.677 30.9539 222.677 24.4012C222.677 17.8486 227.989 12.5352 234.542 12.5352C241.095 12.5352 246.408 17.8486 246.408 24.4012Z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.349 24.4011C239.349 27.0562 237.197 29.2084 234.542 29.2084C231.887 29.2084 229.735 27.0562 229.735 24.4011C229.735 21.7468 231.887 19.5938 234.542 19.5938C237.197 19.5938 239.349 21.7468 239.349 24.4011Z",
  fill: "#317AD0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M151.25 159.793H151.126L150.909 159.781H97.9953L89.9544 150.198H48.2003L45.1188 150.17H44.7401C41.0281 150.17 37.9907 153.207 37.9907 156.919V162.487C37.9907 162.718 37.9676 162.946 37.9907 163.17V166.843V226.421V230.094C37.9676 230.319 37.9907 230.546 37.9907 230.776V236.345C37.9907 240.057 41.0281 243.094 44.7401 243.094H45.1188H48.2003H72.1299V233.697C72.1299 231.847 73.4823 230.195 75.3257 230.019C77.4387 229.816 79.2171 231.474 79.2171 233.546V243.094H116.774V233.697C116.774 231.847 118.127 230.195 119.97 230.019C122.083 229.816 123.862 231.474 123.862 233.546V243.094H147.754H150.909H151.25C154.962 243.094 158 240.057 158 236.345V236.004V230.776V226.421V172.11V166.873V166.542C158 162.83 154.962 159.793 151.25 159.793Z",
  fill: "#B4B4B4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M138.604 173.903H138.345L138.124 173.891H84.1819L75.9847 164.123H33.4186L30.2773 164.092H29.7601C26.0481 164.092 23.0107 167.13 23.0107 170.842V176.65C23.0107 176.885 22.9866 177.116 23.0107 177.345V181.091V241.826V245.572C22.9866 245.8 23.0107 246.033 23.0107 246.268V252.075C23.0107 255.788 26.0481 258.824 29.7601 258.824H30.2773H33.4186H57.813V249.245C57.813 247.359 59.1926 245.673 61.0717 245.493C63.2257 245.289 65.0387 246.977 65.0387 249.09V258.824H103.325V249.245C103.325 247.359 104.705 245.673 106.584 245.493C108.738 245.289 110.551 246.977 110.551 249.09V258.824H134.909H138.124H138.604C142.317 258.824 145.353 255.788 145.353 252.075V251.596V246.268V241.826V186.46V181.12V180.653C145.353 176.94 142.317 173.903 138.604 173.903Z",
  fill: "#DCDCDC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.2324 205.884C71.2324 213.285 66.4314 219.286 60.5088 219.286C54.5862 219.286 49.7852 213.285 49.7852 205.884C49.7852 198.483 54.5862 192.482 60.5088 192.482C66.4314 192.482 71.2324 198.483 71.2324 205.884Z",
  fill: "#317AD0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.0824 224.002C71.0824 224.002 69.773 224.007 69.5548 224.002C69.005 223.986 68.3115 223.896 67.7586 223.687C67.3053 223.517 66.5289 223.198 65.954 222.611C65.2332 221.873 64.9887 221.036 64.9887 219.641V215.59L60.5088 215.892L56.0288 215.59V219.641C56.0288 221.036 55.7843 221.873 55.0635 222.611C54.4886 223.198 53.7122 223.517 53.26 223.687C52.706 223.896 52.0125 223.986 51.4628 224.002C51.2445 224.007 49.9352 224.002 49.9352 224.002H48.2313C45.4625 224.002 43.1963 226.267 43.1963 229.037V231.569C43.1963 231.94 43.4985 232.242 43.8699 232.242H60.3587H60.6588H77.1477C77.5191 232.242 77.8212 231.94 77.8212 231.569V229.037C77.8212 226.267 75.555 224.002 72.7862 224.002H71.0824Z",
  fill: "#317AD0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.663 213.275H89.3942C88.3366 213.275 87.4805 212.417 87.4805 211.361C87.4805 210.304 88.3366 209.447 89.3942 209.447H128.663C129.719 209.447 130.576 210.304 130.576 211.361C130.576 212.417 129.719 213.275 128.663 213.275Z",
  fill: "#B4B4B4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.663 221.737H89.3942C88.3366 221.737 87.4805 220.879 87.4805 219.823C87.4805 218.766 88.3366 217.91 89.3942 217.91H128.663C129.719 217.91 130.576 218.766 130.576 219.823C130.576 220.879 129.719 221.737 128.663 221.737Z",
  fill: "#B4B4B4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M110.797 230.84H89.3942C88.3376 230.84 87.4805 229.984 87.4805 228.927C87.4805 227.871 88.3376 227.014 89.3942 227.014H110.797C111.854 227.014 112.711 227.871 112.711 228.927C112.711 229.984 111.854 230.84 110.797 230.84Z",
  fill: "#B4B4B4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.087 202.254H89.2378C88.2674 202.254 87.4805 201.467 87.4805 200.496V195.103C87.4805 194.133 88.2674 193.346 89.2378 193.346H102.087C103.058 193.346 103.844 194.133 103.844 195.103V200.496C103.844 201.467 103.058 202.254 102.087 202.254Z",
  fill: "#B4B4B4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M129.399 202.254H110.271C109.301 202.254 108.513 201.467 108.513 200.496V195.103C108.513 194.133 109.301 193.346 110.271 193.346H129.399C130.369 193.346 131.156 194.133 131.156 195.103V200.496C131.156 201.467 130.369 202.254 129.399 202.254Z",
  fill: "#B4B4B4"
}));
function SvgGlance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 306,
    viewBox: "0 0 311 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlance);
export default __webpack_public_path__ + "static/media/glance.d7f8bfef.svg";
export { ForwardRef as ReactComponent };